const BASE_API_URL = process.env.VUE_APP_API_BASE_URL || '';

import axios from 'axios';

function apiRequest(axiosOptions, options = {}) {
  let showLoading = true;
  if (typeof options.showLoading === 'boolean') {
    showLoading = options.showLoading;
  }
  if (showLoading) {
    loading(true);
  }
  return new Promise((resolve, reject) => {
    axios(axiosOptions)
      .then(response => {
        if (response.status === 204) {
          resolve({});
        } else {
          resolve(response.data);
        }
      })
      .catch(error => {
        if (options.customHttpErrorHandlers && error.response &&
          options.customHttpErrorHandlers.includes(error.response.status)) {
          reject(error.response);
        } else {
          let errorMessage;
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          } else {
            errorMessage = 'Unknown error';
          }
          dispatchApiErrorEvent({
            error: 'HTTP call error',
            message: errorMessage
          });
          reject(error);
        }
      })
      .then(() => {
        if (showLoading) {
          loading(false);
        }
      });
  });
}

function dispatchApiErrorEvent(error) {
  let event = new CustomEvent('apiError');
  event.message = {
    message: error.message || 'Unknown error',
    title: error.error
  };
  document.dispatchEvent(event);
}

/* For loading animation */
function loading(value) {
  let event = new CustomEvent('loading');
  event.value = value;
  document.dispatchEvent(event);
}

export default {
  init() {
    let url = BASE_API_URL + 'init';
    return apiRequest({
      method: 'GET',
      url,
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    });
  },
  checkInvitedRegistrations() {
    let url = BASE_API_URL + 'check-invited-registration';
    return apiRequest({
      method: 'GET',
      url,
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    }, { showLoading: false });
  },
  search(searchForm, store) {
    let url = BASE_API_URL + 'search';
    return apiRequest({
      method: 'POST',
      url,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data: searchForm
    }, {
      customHttpErrorHandlers: [400]
    });
  },
  getFilesPanel(page) {
    let url = BASE_API_URL + 'userfiles?page=' + page;
    return apiRequest({
      method: 'GET',
      url,
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    }, {
      showLoading: false
    });
  },
  deleteNotification(id, page) {
    let url = BASE_API_URL + 'notification/' + id + '?page=' + page;
    return apiRequest({
      method: 'DELETE',
      url,
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    }, {
      showLoading: false
    });
  },
  startJob(data) {
    let url = BASE_API_URL + 'job';
    return apiRequest({
      method: 'POST',
      url,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data
    }, {
      showLoading: false
    });
  },
  checkJobsStatus() {
    let url = BASE_API_URL + 'jobs';
    return apiRequest({
      method: 'GET',
      url,
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    }, {
      showLoading: false
    });
  },
  clearNotifications(data) {
    let url = BASE_API_URL + 'clearNotifications';
    return apiRequest({
      method: 'POST',
      url,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data
    }, {
      showLoading: false
    });
  },
  keepalive() {
    let url = BASE_API_URL + 'keepalive';
    return apiRequest({
      method: 'GET',
      url,
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    }, {
      showLoading: false
    });
  },
  nameResolver(objectName) {
    let url = BASE_API_URL + 'resolve?object=' + encodeURIComponent(objectName);
    return apiRequest({
      method: 'GET',
      url,
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    }, {
      showLoading: false,
      customHttpErrorHandlers: [400, 404]
    });
  },
  reportError(data) {
    let url = BASE_API_URL + 'error-report';
    return apiRequest({
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      },
      data
    }, {
      showLoading: false
    });
  },
  getSampDownloadUrl(fileUrl) {
    let url = BASE_API_URL + 'download?samp=true&url=' + encodeURIComponent(fileUrl);
    return apiRequest({
      method: 'GET',
      url
    });
  }
};
